import { SimNaoEnum } from 'components/form'

import { ConsultaSeguimentoPergunta13Model } from './model-consultaSeguimentoPergunta13'

export function prunePergunta13(value: ConsultaSeguimentoPergunta13Model): ConsultaSeguimentoPergunta13Model {
  const pruned: ConsultaSeguimentoPergunta13Model = {
    status: value.status,
    resultado: value.resultado,
    PERGUNTA_13_HEADER: value.PERGUNTA_13_HEADER,
  }

  if (value.PERGUNTA_13_HEADER === SimNaoEnum.SIM) {
    pruned.PERGUNTA_13_ANDA_SEM_APOIO = value.PERGUNTA_13_ANDA_SEM_APOIO
  }

  return pruned
}
